import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const bootstrap = useCallback(async () => {
    const started = Date.now();
    const steps = [() => api.get("/auth/me"), () => api.post("/auth/refresh"), () => api.post("/auth/guest")];
    for (const step of steps) {
      try {
        const { data } = await step();
        // Let the logo loader finish one gentle fill before the app appears.
        await new Promise((r) => setTimeout(r, Math.max(0, 1100 - (Date.now() - started))));
        setUser(data);
        return;
      } catch {
        // try next step
      }
    }
  }, []);

  useEffect(() => {
    // Returning from Google: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) return;
    if (window.location.pathname.startsWith("/w/")) return;
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => setUser((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) => setUser((await api.post("/auth/register", { name, email, password })).data);
  const completeGoogle = async (session_id) => setUser((await api.post("/auth/google/session", { session_id })).data);
  const logout = async () => {
    await api.post("/auth/logout");
    setUser((await api.post("/auth/guest")).data);
  };
  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, googleLogin, completeGoogle, bootstrap }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
